"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var Localize_1 = require("../../../gen-src/Localize");
var ColumnDetailsQueryGql_1 = require("../../queries/ColumnDetailsQueryGql");
var ColumnDetailsStyles_1 = require("../../style/ColumnDetailsStyles");
var RemoteTypeMapping_1 = require("../../utils/RemoteTypeMapping");
var RemoteTypeIcon_1 = require("../datagrid/cellFormatters/RemoteTypeIcon");
var renderQueryResult_1 = require("../renderQueryResult");
var LinksDisplayGrid_1 = require("../sharedDisplayGrid/LinksDisplayGrid");
var ColumnFieldsQueryGrid_1 = require("./ColumnFieldsQueryGrid");
var ColumnFlowsQueryGrid_1 = require("./ColumnFlowsQueryGrid");
var ColumnInlineDescriptionEditor_1 = require("./ColumnInlineDescriptionEditor");
var dialogWidth = 600;
var ColumnDetailsDialog = /** @class */ (function (_super) {
    __extends(ColumnDetailsDialog, _super);
    function ColumnDetailsDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderColumnDetailsDialog = function (data) {
            var column = data.columns && data.columns[0];
            if (!column) {
                return null;
            }
            var fieldsCount = column.referencedByFieldsConnection ? column.referencedByFieldsConnection.totalCount : null;
            var flowsCount = column.referencedByFlowColumnInputFieldConnection ? column.referencedByFlowColumnInputFieldConnection.totalCount : null;
            return (React.createElement(widgets_1.DialogWidget, { testId: 'column-details', title: Localize_1.Messages.ColumnDetails(), type: widgets_1.DialogType.NormalWithTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Centered, showCloseButton: true, showFooter: false, isModal: true, onCloseRequest: _this.props.onClose, handleGlassClick: _this.props.onClose, dialogWidth: dialogWidth },
                React.createElement(ColumnDetailsStyles_1.ColumnDetailsPane, null,
                    React.createElement(ColumnDetailsStyles_1.ColumnDetailsColumnName, null, column.name),
                    React.createElement(ColumnDetailsStyles_1.ColumnDetailsTypeRow, null,
                        React.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: column.remoteType }),
                        RemoteTypeMapping_1.RemoteTypeMappings[column.remoteType]()),
                    React.createElement(ColumnDetailsStyles_1.ColumnDetailsProperties, null,
                        React.createElement(ColumnInlineDescriptionEditor_1.ColumnInlineDescriptionEditor, { columnVizportalId: column.vizportalId, tableVizportalId: _this.props.tableVizportalId, description: column.description || '', apiRequests: _this.props.apiRequests, onUpdate: _this.props.onUpdate }),
                        React.createElement(ColumnDetailsStyles_1.ColumnDetailsProperty, null,
                            React.createElement(ColumnDetailsStyles_1.ColumnDetailsLabel, null, Localize_1.Messages.UsedByFields()),
                            React.createElement(ColumnDetailsStyles_1.ColumnFieldsWrapper, { style: { height: LinksDisplayGrid_1.getRowHeight(fieldsCount, ColumnDetailsStyles_1.columnFieldsWrapperMaxRows) } },
                                React.createElement(ColumnFieldsQueryGrid_1.ColumnFieldsQueryGrid, { columnId: _this.props.columnId, rowCount: fieldsCount }))),
                        React.createElement(ColumnDetailsStyles_1.ColumnDetailsProperty, null,
                            React.createElement(ColumnDetailsStyles_1.ColumnDetailsLabel, null, Localize_1.Messages.UsedByFlows()),
                            React.createElement(ColumnDetailsStyles_1.ColumnFieldsWrapper, { style: { height: LinksDisplayGrid_1.getRowHeight(flowsCount, ColumnDetailsStyles_1.columnFieldsWrapperMaxRows) } },
                                React.createElement(ColumnFlowsQueryGrid_1.ColumnFlowsQueryGrid, { columnId: _this.props.columnId, rowCount: flowsCount })))))));
        };
        return _this;
    }
    ColumnDetailsDialog.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_apollo_1.Query, { query: ColumnDetailsQueryGql_1.ColumnDetailsQueryGql, variables: { columnId: this.props.columnId } }, function (result) { return renderQueryResult_1.renderQueryResult(result, { renderData: _this.renderColumnDetailsDialog }); }));
    };
    return ColumnDetailsDialog;
}(React.Component));
exports.ColumnDetailsDialog = ColumnDetailsDialog;
//# sourceMappingURL=ColumnDetailsDialog.js.map